import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const ConfirmationCheckIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="20"
        height="14"
        viewBox="0 0 20 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.9427 1.0572C19.4634 1.5779 19.4634 2.42212 18.9427 2.94281L8.276 13.6095C7.7553 14.1302 6.91108 14.1302 6.39038 13.6095L1.05727 8.27637C0.536573 7.75567 0.536573 6.91145 1.05727 6.39075C1.57797 5.87005 2.42219 5.87005 2.94289 6.39075L7.33319 10.7811L17.057 1.0572C17.5777 0.536497 18.422 0.536497 18.9427 1.0572Z"
          fill="white"
        />
      </svg>
    );
  }
);
export default ConfirmationCheckIcon;
